import React from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider }         from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { PixelToastContainer }  from "./components/common/PixelToast";
import AppRouter                from "./router/AppRouter";
import AtariBackground          from "./components/common/AtariBackground";
import AtariCursor              from "./components/common/AtariCursor";

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <NotificationProvider>
        <AtariBackground />
        <AtariCursor />
        <div style={{ position: "relative", zIndex: 1 }}>
          <AppRouter />
          <PixelToastContainer />
        </div>
      </NotificationProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;